import { Controller } from 'stimulus';
import { Gauge } from 'gaugeJS';

const GAUGE_MIN = 0;
const GAUGE_MAX = 1400;

export default class extends Controller {
  static targets = ['score', 'canvas'];

  get score() {
    return Number(this.scoreTarget.textContent);
  }

  connect() {
    const opts = {
      angle: 0,
      lineWidth: 0.44,
      pointer: {
        length: 0.9,
        strokeWidth: 0.035,
      },
      colorStart: '#6FADCF',
      colorStop: '#8FC0DA',
      strokeColor: '#E0E0E0',
    };
    const target = this.canvasTarget;
    const gauge = new Gauge(target).setOptions(opts);
    gauge.maxValue = Number(this.data.get('max') || GAUGE_MAX);
    gauge.setMinValue(Number(this.data.get('min') || GAUGE_MIN));
    gauge.set(this.score);
  }
}
